import {
  LinkBox,
  LinkOverlay,
  Stack,
  Flex,
  Button,
  Text,
  VStack,
  useBreakpointValue,
  ChakraProvider

} from '@chakra-ui/react'

import modisafpixel from './data/img/modis_af_pixels.png'


const MODISCard = () => {
  return (
    <ChakraProvider>
    <Flex
      w={"full"}
      h={"40vh"}
      backgroundImage={
        modisafpixel
      }
      backgroundSize={"cover"}
      backgroundPosition={"center center"}
      borderRadius={"lg"}
    >
      <VStack
        w={"full"}
        justify={"center"}
        px={useBreakpointValue({ base: 4, md: 8 })}
        bgGradient={"linear(to-r, blackAlpha.600, transparent)"}
        borderRadius={"lg"}
      >
        <Stack maxW={"2xl"} align={"flex-start"} spacing={6}>
          <Text
            color={"white"}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={useBreakpointValue({ base: "3xl", md: "4xl" })}
          >
            MODIS
          </Text>
          <Stack direction={"row"}>
            <LinkBox>
              <LinkOverlay href="https://lpdaac.usgs.gov/products/mcd64a1v061/">
                <Button
                  bg={"green.400"}
                  rounded={"full"}
                  color={"white"}
                  _hover={{ bg: "green.500" }}
                >
                 Learn more
                </Button>
              </LinkOverlay>
            </LinkBox>
            <LinkBox>
              <LinkOverlay href='/publications'>
                <Button
                  bg={"whiteAlpha.300"}
                  rounded={"full"}
                  color={"white"}
                  _hover={{ bg: "whiteAlpha.500" }}
                >
                  Explore Publications
                </Button>
              </LinkOverlay>
            </LinkBox>
          </Stack>
        </Stack>
      </VStack>
    </Flex>
    </ChakraProvider >
  )
}

export default MODISCard